import React, { useRef, useState } from 'react';

import MobilePhotoInput from '../../../components/ui/MobilePhotoInput';

const PhotoUploadZone = ({ onFilesSelected, uploading }) => {
  const [dragging, setDragging] = useState(false);

  return (
    <div className="space-y-3">
      <MobilePhotoInput
        label="Upload Photos"
        onFilesSelected={onFilesSelected}
        uploading={uploading}
        multiple
        hint="JPEG, PNG, WebP · Max 10MB each"
      />
    </div>
  );
};

export default PhotoUploadZone;
